import * as React from "react";
const SvgArrowBack = props => <svg xmlns="http://www.w3.org/2000/svg" width={14} height={26} fill="none" viewBox="0 0 14 26" {...props}><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 25 1 13 13 1" /></svg>;
export default SvgArrowBack;